(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dibor.pdp-stock-finance"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.diborStockFinance) return
    window.diborStockFinance = true
    const init = (root) => {
      if (root.dataset.ready) return
      root.dataset.ready = '1'
      let variants = []
      try { variants = JSON.parse(root.querySelector('[data-dibor-sf-variants]').textContent) } catch (e) { return }
      const outlet = root.dataset.outlet === 'true'
      const form = document.getElementById(root.dataset.formId)
      const input = form && form.querySelector('input[name="id"]')
      if (!input) return
      const fin = root.querySelector('[data-dibor-sf-fin]')
      const low = root.querySelector('[data-dibor-sf-low]')
      const lowText = root.querySelector('[data-dibor-sf-lowtext]')
      const draw = () => {
        const v = variants.find((x) => String(x.id) === String(input.value))
        if (!v) return
        fin.hidden = !(v.p > 7500)
        if (outlet && v.q !== null && v.q > 0 && v.q < 10) {
          lowText.innerHTML = v.q === 1
            ? '<strong>Don&rsquo;t miss out</strong> &ndash; Last one left online'
            : '<strong>Don&rsquo;t miss out</strong> &ndash; Only ' + v.q + ' left in stock online'
          low.hidden = false
        } else { low.hidden = true }
      }
      input.addEventListener('change', draw)
      new MutationObserver(draw).observe(input, { attributes: true, attributeFilter: ['value'] })
      document.addEventListener('variant:change', () => setTimeout(draw, 0))
      setInterval(() => { if (input.value !== root.dataset.last) { root.dataset.last = input.value; draw() } }, 500)
      draw()
    }
    const run = () => document.querySelectorAll('[data-dibor-sf]').forEach(init)
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run)
    else run()
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dibor.promo-price"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.diborPromoPrice) return
    window.diborPromoPrice = true

    const nowS = () => Math.floor(Date.now() / 1000)
    // data-dibor-promo-ends="0" means no end date (runs while stocks last).
    // 15/10/2026: data-dibor-promo-starts (only on a code waiting for its start date) must have passed too,
    // so a pending code is never added to the basket.
    const started = (el) => {
      const starts = Number(el.dataset.diborPromoStarts)
      return !starts || starts <= nowS()
    }
    const live = (el) => {
      const ends = Number(el.dataset.diborPromoEnds)
      return started(el) && (!ends || ends > nowS())
    }
    const ended = (el) => {
      const ends = Number(el.dataset.diborPromoEnds)
      return !!ends && ends <= nowS()
    }

    // What a pending code replaces at its start: the next [data-dibor-promo-pre], skipping the fallback.
    const preOf = (el) => {
      let n = el.nextElementSibling
      if (n && n.classList.contains('dibor-promo__fallback')) n = n.nextElementSibling
      return n && n.hasAttribute('data-dibor-promo-pre') ? n : null
    }

    // 15/10/2026: a dated code whose start has come. Pages are cached and tabs stay open over midnight, so the
    // browser swaps it in: show the code price and badge, drop the "before" price (BMSM or normal).
    const start = (root = document) => {
      root.querySelectorAll('[data-dibor-promo-starts]').forEach((el) => {
        if (!started(el) || ended(el)) return
        const pre = preOf(el)
        if (pre) pre.remove()
        el.removeAttribute('data-dibor-promo-starts')
        el.hidden = false
      })
    }

    // Pages are cached, so a promo can still be in the HTML after it ends. Put the normal price back.
    const expire = (root = document) => {
      root.querySelectorAll('[data-dibor-promo-ends]').forEach((el) => {
        if (!ended(el)) return
        const fallback = el.nextElementSibling
        // A code that ended before it was ever swapped in keeps its "before" price; otherwise the normal price.
        if (!preOf(el) && fallback && fallback.classList.contains('dibor-promo__fallback')) fallback.hidden = false
        el.remove()
      })
    }

    // Add the code to the cart without removing any code the customer already has.
    // 14/10/2026 (D-257, Sameer's 13/10 review #1 + #5): success = the cart Shopify returns really holds every
    // code. A refused or failed update is retried once 3 s later, and again on the next page view or quick add.
    // Cart URLs follow the market route.
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
    const codesIn = (cart) => ((cart && cart.discount_codes) || []).map((d) => String(d.code).toUpperCase())
    // 14/10/2026 (D-257 follow-up): no "already done" memory in the tab any more. A remembered flag stopped the
    // code being re-added once it had left the basket (order placed, code removed) while the page still said
    // "Applied automatically". The basket is read every time (one small cart.js GET, only on the 4-ish promo
    // product pages and promo quick-adds); a code already there costs nothing more.
    // 15/10/2026 (D-288 B2, Sameer 15/10 #2): the product page no longer says "Applied automatically" up front. It shows
    // what the basket really holds: success = Shopify reports the code APPLICABLE on a basket that holds this product,
    // not just the code's name in the basket. A code Shopify refuses (e.g. a bundle offer it can't combine with) or a
    // failed update shows "Enter CODE at checkout" instead of a false confirmation.
    // 18/10/2026 (Sameer audit 18/10 #3): "applied" now needs proof on the line itself: the code is reported
    // applicable === true (a missing field no longer counts) AND a line of THIS product carries a discount allocation
    // titled with the code, amount > 0 (cart.js line_level_discount_allocations, checked live 18/10 on AUTUMN20).
    // Code in the basket but this product not yet = "saved". Code there but not on this product's line = "refused".
    const stateOf = (cart, code, pid) => {
      const d = ((cart && cart.discount_codes) || []).find((x) => String(x.code).toUpperCase() === code)
      if (!d) return 'missing'
      const lines = pid ? (cart.items || []).filter((i) => String(i.product_id) === String(pid)) : []
      if (!lines.length) return 'saved'
      if (d.applicable !== true) return 'refused'
      const got = lines.some((i) =>
        (i.line_level_discount_allocations || []).some(
          (a) => a && a.amount > 0 && a.discount_application && String(a.discount_application.title).toUpperCase() === code
        )
      )
      return got ? 'applied' : 'refused'
    }
    const pidFor = (code) => {
      const el = document.querySelector('[data-dibor-promo-status="' + code + '"]')
      return el && el.dataset.diborPromoProduct
    }
    const showStatus = (cart, failed) => {
      document.querySelectorAll('[data-dibor-promo-status]').forEach((el) => {
        const c = String(el.dataset.diborPromoStatus).toUpperCase()
        const st = cart ? stateOf(cart, c, el.dataset.diborPromoProduct) : 'missing'
        if (st === 'applied') el.textContent = 'Applied in your basket'
        else if (st === 'saved') el.textContent = 'Code saved in your basket'
        else if (failed) el.textContent = 'Enter ' + c + ' at checkout'
      })
    }
    const apply = async (codes, retry = 1) => {
      codes = [...new Set(codes.map((c) => c.toUpperCase()))]
      if (!codes.length) return
      let cart = null
      try {
        const r0 = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
        if (!r0.ok) throw new Error('cart ' + r0.status)
        cart = await r0.json()
        const existing = codesIn(cart)
        if (!codes.every((c) => existing.includes(c))) {
          const merged = [...new Set([...existing, ...codes])]
          const r = await fetch(root + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: merged.join(',') })
          })
          cart = r.ok ? await r.json() : null
        }
      } catch (e) {
        cart = null
      }
      const bad = !cart || codes.some((c) => ['missing', 'refused'].includes(stateOf(cart, c, pidFor(c))))
      if (!bad || retry === 0) showStatus(cart, bad)
      if (bad && retry > 0) setTimeout(() => apply(codes, retry - 1), 3000)
    }
    // Read-only re-check after the basket changes (add to basket, Smart Cart edits). It never writes the basket,
    // so it cannot loop with the basket apps' own change events.
    let checkTimer = 0
    const check = () => {
      if (!document.querySelector('[data-dibor-promo-status]')) return
      clearTimeout(checkTimer)
      checkTimer = setTimeout(async () => {
        try {
          const r = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
          if (!r.ok) return
          const cart = await r.json()
          const codes = [...document.querySelectorAll('[data-dibor-promo-status]')].map((el) => String(el.dataset.diborPromoStatus).toUpperCase())
          showStatus(cart, codes.some((c) => ['missing', 'refused'].includes(stateOf(cart, c, pidFor(c)))))
        } catch (e) {}
      }, 600)
    }
    document.addEventListener('cart:updated', check)
    document.addEventListener('rebuy:cart.change', check)
    document.addEventListener('click', (e) => { if (e.target.closest('[name="add"], [data-dibor-sticky-btn]')) setTimeout(check, 2500) }, true)

    const activeCodes = (selector) =>
      [...document.querySelectorAll(selector)]
        .filter(live)
        .map((el) => el.dataset.diborPromoCode)

    // Variant changes and quick shop swap price markup in: check the new markup for expiry as well.
    // Only on pages that carry a promo, so the other ~1,800 product pages pay nothing.
    const watch = () => {
      if (!document.querySelector('[data-dibor-promo-ends], [data-dibor-promo-watch]')) return
      new MutationObserver((records) => {
      for (const r of records) {
        for (const n of r.addedNodes) {
          if (n.nodeType === 1 && (n.matches?.('[data-dibor-promo-ends]') || n.querySelector?.('[data-dibor-promo-ends]'))) {
            start(n.parentNode || document)
            expire(n.parentNode || document)
            if (n.querySelector?.('.dibor-promo--pdp') || n.matches?.('.dibor-promo--pdp')) {
              apply(activeCodes('.dibor-promo--pdp[data-dibor-promo-code]'))
            }
          }
        }
      }
      }).observe(document.documentElement, { childList: true, subtree: true })
    }

    const run = () => {
      watch()
      start()
      expire()
      // Product page: the customer is looking at the promoted product, add its code.
      apply(activeCodes('.dibor-promo--pdp[data-dibor-promo-code]'))
    }

    // 14/10/2026 (D-275 A1, Sameer 14/10 #6c): one timer for the next end time, so a tab left open still drops an
    // ended code price on time (the main price, badge and fallback together).
    // 15/10/2026: start times share the same timer; at a start the code price appears and, on the product page,
    // the code goes into the basket.
    const scheduleExpiry = () => {
      const ends = [...document.querySelectorAll('[data-dibor-promo-ends]')].map((el) => Number(el.dataset.diborPromoEnds))
      const starts = [...document.querySelectorAll('[data-dibor-promo-starts]')].map((el) => Number(el.dataset.diborPromoStarts))
      const next = [...ends, ...starts].filter((t) => t > nowS())
      if (!next.length) return
      const ms = (Math.min(...next) - nowS()) * 1000 + 500
      if (ms < 2147483647) setTimeout(() => {
        start()
        expire()
        apply(activeCodes('.dibor-promo--pdp[data-dibor-promo-code]'))
        scheduleExpiry()
      }, ms)
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleExpiry)
    else scheduleExpiry()

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run)
    else run()

    // A tab left open past the end time: hide the promo as soon as the customer comes back to it.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') return
      start()
      expire()
      // and re-add the code if it left the basket while the customer was away (e.g. checked out in another tab)
      apply(activeCodes('.dibor-promo--pdp[data-dibor-promo-code]'))
    })

    // Quick add from a collection tile skips the product page, so add the code on that click too.
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('.quick-add-btn, [data-single-variant-quick-add]')
        if (!button) return
        const card = button.closest('.product-grid-item')
        const promo = card && card.querySelector('.dibor-promo[data-dibor-promo-code]')
        if (promo && live(promo)) apply([promo.dataset.diborPromoCode])
      },
      true
    )

  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super()
      this.select = null
      this.buttonText = null
      this.button = null
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select')
      this.button = this.querySelector('.element-button')

      if (this.select && this.button) {
        this.init()
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-text') || this.button.querySelector('[data-button-text]')

      // Set initial text
      this.updateButtonText()

      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e))

      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e))

      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText())

      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus())
      this.select.addEventListener('blur', () => this.handleBlur())
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault()
      e.stopPropagation()

      // Trigger the native select
      this.select.focus()
      this.select.click()
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault()
          this.select.click()
          break
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break
        default:
          // Let other keys pass through
          break
      }
    }

    updateButtonText() {
      if (!this.buttonText) return

      const selectedOption = this.select.options[this.select.selectedIndex]
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option'
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused')
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused')
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e))
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e))
        this.select.removeEventListener('change', () => this.updateButtonText())
        this.select.removeEventListener('focus', () => this.handleFocus())
        this.select.removeEventListener('blur', () => this.handleBlur())
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.customer"] && !Shopify.designMode) return;
  try {
    class FormCustomer extends HTMLElement {
    static emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

    connectedCallback() {
      this.controller?.abort()
      const { signal } = (this.controller = new AbortController())

      const form = this.querySelector('form')
      const input = form?.querySelector('input[name="contact[email]"]')
      if (!input) return

      const validate = () => {
        const ok = FormCustomer.emailPattern.test(input.value.trim())
        input.setCustomValidity(ok ? '' : this.dataset.invalidMessage)
      }

      input.addEventListener('input', validate, { signal })
      form.addEventListener(
        'submit',
        (e) => {
          validate()
          if (!form.reportValidity()) e.preventDefault()
        },
        { signal, passive: false }
      )
    }

    disconnectedCallback() {
      this.controller?.abort()
    }
  }

  customElements.define('form-customer', FormCustomer)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.attachShadowRoots(this)
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return
      }

      element.querySelectorAll('template[shadowrootmode]').forEach((template) => {
        const mode = template.getAttribute('shadowrootmode')
        const shadowRoot = template.parentNode.attachShadow({ mode })

        shadowRoot.appendChild(template.content)
        template.remove()
        this.attachShadowRoots(shadowRoot)
      })
    }
  }

  customElements.define('layout-grid', LayoutGrid)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.attachShadowRoots(this)
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return
      }

      element.querySelectorAll('template[shadowrootmode]').forEach((template) => {
        const mode = template.getAttribute('shadowrootmode')
        const shadowRoot = template.parentNode.attachShadow({ mode })

        shadowRoot.appendChild(template.content)
        template.remove()
        this.attachShadowRoots(shadowRoot)
      })
    }
  }

  customElements.define('layout-stack', LayoutStack)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["list.product-card.hover-image"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.diborHoverVideo) return;
    window.diborHoverVideo = true;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var activeCard = null;

    function videoIn(card) {
      return card ? card.querySelector('.dibor-hover-video video') : null;
    }

    function stop(card) {
      var video = videoIn(card);
      if (!video) return;
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
    }

    // One delegated listener, so cards added later (filters, infinite scroll, Rebuy) work too
    document.addEventListener('mouseover', function (event) {
      var card = event.target.closest ? event.target.closest('.grid-product') : null;
      if (card === activeCard) return;
      stop(activeCard);
      activeCard = card;
      if (reduceMotion) return;
      var video = videoIn(card);
      if (!video) return;
      if (!video.getAttribute('src') && video.dataset.src) video.src = video.dataset.src;
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
